export default "__VITE_ASSET__BXYinLt$__"